import React, { useState, useEffect } from 'react'
import './ProductoDetalleImplantacionPage.scss';
import Path from '../components/Path'
import { useNavigate, useParams } from 'react-router-dom';
import { ProductImageSlider } from '../components/ProductImageSlider';
import { ProductoDetalleHeader } from '../components/ProductoDetalleHeader'
import ProductoDetalleBtnCompra from '../components/ProductoDetalleBtnCompra'
import ProductoDetalleCantidad from '../components/ProductoDetalleCantidad'
import { ProductoDetalleDescripcion } from '../components/ProductoDetalleDescripcion'
import Separator from '../components/Separator';
import { connect as connectRedux } from 'react-redux'
import { NavLink } from 'react-router-dom';
import * as _ from 'lodash'
import { privilegeUser } from '../hooks/user';
import { scrollBodyTop } from '../hooks/scrollPosition';
import ContentExpositor from '../components/ContentExpositor';
import { useActiveDesactiveSrollBody } from '../hooks/activeDesactivScrollBody';
import {OptionsProductDesactivate} from '../components/OptionsProductDesactivate';
import { getProducts, getProductsOutlet, getProductsPromoA, getProductsPromoB, getProductsPromoC } from '../hooks/gets';
import { productInOutlet } from '../hooks/productInOutlet'
import { BRANDCHOSEN, PreChangeBrandChosen } from '../hooks/config';
import { setFormatSelected, setBudgetImplantacion, showPopup } from '../actions/index'

const findProductById = (allProducts, id) => {
    for (let i = 0; i < allProducts.length; i++) {
        const el = allProducts[i];
        if (el.ID === id) {
            return el
        }
    }
}

const findProductsImplantationById = (product, allProduct) => {
    const productImplantations = JSON.parse(product.ProductosExpositor);
    let productsInImplantation = []
    for (let i = 0; i < productImplantations.length; i++) {
        const product = productImplantations[i];
        const productData = _.filter(allProduct[BRANDCHOSEN], productList => {
            return productList.RefSuelto.trim() === product.RefSuelto.trim()
        })
        const productQuantity = { product: productData[0], quantity: product.Quantity }
        productsInImplantation.push(productQuantity)
    }
    return productsInImplantation;
}

const ProductoDetalleImplantationPage = (props) => {
    const { id } = useParams(); // Get product id from the URL
    const navigate = useNavigate(); // Navigate hook
    const [product, setProduct] = useState(undefined)
    const [productsImplantation, setProductsImplantation] = useState([])
    const [productInImplantation, setProductInImplantation] = useState(false)
    const [totalPriceImplantations, setTotalPriceImplantations] = useState('')
    const [privilege, setPrivilege] = useState(undefined)
    const [ShowProductComplement,setShowProductComplement] = useState(false)

    const [outlet, setOutlet] = useState([])
    const [promoA, setPromoA] = useState([])
    const [promoB, setPromoB] = useState([])
    const [promoC, setPromoC] = useState([])

    useEffect(() => {
        scrollBodyTop()
        getPrivilege()
        loadProducts()
        props.setFormatSelected('implantacion')
        PreChangeBrandChosen()
    }, [])

    const loadProducts = async () => {
        setOutlet(await getProductsOutlet())
        setPromoA(await getProductsPromoA())
        setPromoB(await getProductsPromoB())
        setPromoC(await getProductsPromoC())
    }

    const getPrivilege = async () => {
        setPrivilege(await privilegeUser())
    }

    useEffect(() => {
        loadData().then(()=>{
          //Necesario para que se ejecute despues de crearse el componente
        })
    }, [props.allProducts, props.match.params.id, outlet, promoA, promoB, promoC])


    const loadData = () => {
      return new Promise((res)=>{
        getProducts().then(async res => {
            const productData = findProductById(props.allProducts, props.match.params.id)
            if (productData !== undefined) {
                const productsImplantation = findProductsImplantationById(productData, res)
                const product = await productInOutlet(productData)
                if (product !== undefined) {
                  productData.Descuento = product.Descuento
                  productData.PrecioTarifa = product.PrecioTarifa
                }
                setTotalPriceImplantations(productData.PrecioTarifa)
                setProductsImplantation(productsImplantation)
                setProduct(productData)
            }
        })
        res()
      })

    }

    const handleSelectProductInImplantation = (product) => {
        setShowProductComplement(true)
        setProductInImplantation(product.product)
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useActiveDesactiveSrollBody(true)
    }

    const preSetBudgetImplantacion = () =>  {
      for (let i = 0; i < productsImplantation.length; i++) {
        const element = productsImplantation[i];
        let format = ''
        if(parseInt(element.product.UnidadesPack)){
          format = 'UnidadesPack'
        }else if(parseInt(element.product.UnidadesPallet)){
          format = 'UnidadesPallet'
        }else if(parseInt(element.product.UVenta2021Suelto)){
          format = 'UVenta2021Suelto'
        }
        const productValues = {
            product: element.product,
            quantity: element.quantity / element.product[format],
            format: format,
            total: element.quantity,
        }
        props.setBudgetImplantacion(productValues)
      }
      showPopup({ active: true, message: 'Productos añadidos', type: 'success' })
    }

    const getTotalPrice = () =>   {
      if (productsImplantation.length > 0) {
        let totalTemp = 0
        for (let i = 0; i < productsImplantation.length; i++) {
          const product = productsImplantation[i];
          const priceUnitString = product.product.PrecioTarifa.replace(',', '.')
          const priceUnitNumber = parseFloat(priceUnitString)
          const price = product.quantity * priceUnitNumber;
          totalTemp += price
        }
        const totalString = totalTemp.toFixed(2).toString()
        const total = totalString.replace('.', ',')
        setTotalPriceImplantations(total);
      } else {
        setTotalPriceImplantations('');
      }
    }

    return (
        <div className="productos-detalle-expositor-page-container productos-detalle-implantacion-page-container">
            {product !== undefined &&
                <React.Fragment>
                    <div className="path">
                        <Path path="Inicio" />
                    </div>
                    <div className="product">
                        <div className="img">
                            <ProductImageSlider product={product}></ProductImageSlider>
                        </div>
                        <div className="title">
                            <ProductoDetalleHeader product={product} nombre={product.Nombre} descuento={product.Descuento} productsTable={props.productsTable}></ProductoDetalleHeader>
                            <div className="separator">
                                <Separator />
                            </div>
                        </div>
                        <div className="options mobile"> 
                            {!_.isEmpty(props.userActive) ?
                                <React.Fragment>
                                    <div><ProductoDetalleCantidad producto={product} /></div>
                                    <div className="boton-compra"><ProductoDetalleBtnCompra preSetBudgetImplantacion={preSetBudgetImplantacion} product={product}productType='implantacion'></ProductoDetalleBtnCompra></div>
                                    <div className="precio">
                                        {privilege &&
                                            <p>Precio de venta recomendado <strong>{totalPriceImplantations}€</strong></p>
                                        }
                                    </div>
                                </React.Fragment>
                                :
                                <OptionsProductDesactivate></OptionsProductDesactivate>
                            }

                        </div>
                        <div className="details">
                            <div className="description mobile">
                                <div className="separator"><Separator /></div>
                                <ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion>
                                <div className="separator"><Separator /></div>
                            </div>

                            <div className="description-count desktop">
                                <div className="description">
                                    <ProductoDetalleDescripcion producto={product}></ProductoDetalleDescripcion>
                                    <div className="separator"><Separator /></div>
                                </div>
                            </div>

                            <ContentExpositor productType='implantacion' setProductsInImplantationAll={setProductsImplantation} productsExpositor={productsImplantation} product={productInImplantation} clickProductSelected={handleSelectProductInImplantation} setTotalPrice={getTotalPrice}></ContentExpositor>

                            <div className="separator"><Separator /></div>
                            <div className="description-count desktop">
                                <div className="count">
                                    {!_.isEmpty(props.userActive) ?
                                        <React.Fragment>
                                            {/* <div className="cantidad"><ProductoDetalleCantidad producto={product} /></div> */}
                                            <div className="boton-compra"><ProductoDetalleBtnCompra preSetBudgetImplantacion={preSetBudgetImplantacion} product={product} productType='implantacion'></ProductoDetalleBtnCompra></div>
                                            <div className="precio">
                                                {privilege &&
                                                    <p>Precio de venta recomendado <strong>{totalPriceImplantations}€</strong></p>
                                                }
                                            </div>

                                        </React.Fragment>
                                        :
                                        <OptionsProductDesactivate></OptionsProductDesactivate>
                                    }
                                </div>
                            </div>


                        </div>

                    </div>
                </React.Fragment>
            }
        </div>
    )
}
const mapDispatchToProps = {
    setFormatSelected,
    setBudgetImplantacion, 
    showPopup
}

const mapStateToProps = state => state

export default connectRedux(mapStateToProps, mapDispatchToProps)(ProductoDetalleImplantationPage)